// @flow

export const MACHINES_REQUEST = 'Machine/MACHINES_REQUEST';
export const MACHINES_SUCCESS = 'Machine/MACHINES_SUCCESS';
export const ADD_MACHINE_REQUEST = 'Machine/ADD_MACHINE_REQUEST';
export const ADD_MACHINE_SUCCESS = 'Machine/ADD_MACHINE_SUCCESS';
export const SERVER_STATUS_REQUEST = 'Machine/SERVER_STATUS_REQUEST';
export const SERVER_STATUS_SUCCESS = 'Machine/SERVER_STATUS_SUCCESS';
export const NO_OF_REQUEST = 'Machine/NO_OF_REQUEST';
export const NO_OF_REQUEST_SUCCESS = 'Machine/NO_OF_REQUEST_SUCCESS';
export const ALL_LOGS_REQUEST = 'Machine/ALL_LOGS_REQUEST';
export const ALL_LOGS_SUCCESS = 'Machine/ALL_LOGS_SUCCESS';
export const ALERT_LOGS_REQUEST = 'Machine/ALERT_LOGS_REQUEST';
export const ALERT_LOGS_SUCCESS = 'Machine/ALERT_LOGS_SUCCESS';
export const BILLING_DETAILS_REQUEST = 'Machine/BILLING_DETAILS_REQUEST';
export const BILLING_DETAILS_SUCCESS = 'Machine/BILLING_DETAILS_SUCCESS';
export const AUCTION_DETAILS_REQUEST = 'Machine/AUCTION_DETAILS_REQUEST';
export const AUCTION_DETAILS_SUCCESS = 'Machine/AUCTION_DETAILS_SUCCESS';
export const CARD_DETAILS_REQUEST = 'Machine/CARD_DETAILS_REQUEST';
export const CARD_DETAILS_SUCCESS = 'Machine/CARD_DETAILS_SUCCESS';
export const REPORTS_SUCCESS = 'Machine/REPORTS_SUCCESS';
export const REPORTS_REQUEST = 'Machine/REPORTS_REQUEST';
export const FETCH_CARD_SWAP_LOGS_REQUEST = 'Machine/FETCH_CARD_SWAP_LOGS_REQUEST';
export const FETCH_CARD_SWAP_LOGS_SUCCESS = 'Machine/FETCH_CARD_SWAP_LOGS_SUCCESS';
export const FETCH_CARD_SWAP_LOGS_FAILURE = 'Machine/FETCH_CARD_SWAP_LOGS_FAILURE';
